import { Menu } from 'lucide-react'
import { useState } from 'react'

import {
  Sheet,
  SheetContent,
  SheetTitle,
  SheetTrigger
} from '@/components/ui/sheet'

import { AppSidebar } from './AppSidebar'
import { NavItem } from './navConfig'

export function MobileNav({ items }: { items: NavItem[] }) {
  const [open, setOpen] = useState(false)

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <button
          type="button"
          aria-label="Open navigation"
          className="flex h-10 w-10 items-center justify-center rounded-xl text-ink transition-colors hover:bg-ink/[0.05] lg:hidden"
        >
          <Menu className="h-6 w-6" />
        </button>
      </SheetTrigger>
      <SheetContent side="left" className="w-72 p-0">
        <SheetTitle className="sr-only">Menu</SheetTitle>
        <AppSidebar items={items} onNavigate={() => setOpen(false)} />
      </SheetContent>
    </Sheet>
  )
}
